import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { Booking } from '../../booking/booking'
import { Product } from '../../product/product'

@Injectable({
  providedIn: 'root'
})
export class OrganizeBookingService {
  private key: string
  private participantCount: number
  private targetLinkedProductId: number
  private isSaved = false

  constructor() {
    this.initialize()
  }

  public initialize() {
    this.key = ''
    this.participantCount = 0
    this.isSaved = false
  }

  public saveValue(params: {
    keyValue: string
    participantCountValue: number
    targetLinkedProductId?: number
  }) {
    this.key = params.keyValue
    this.participantCount = params.participantCountValue
    this.targetLinkedProductId = params.targetLinkedProductId
    this.isSaved = true
  }

  public getFilteredBookingsByDateAndProduct(
    bookings: Booking[],
    product: Product,
    date: Date
  ): Booking[] {
    return bookings?.filter((booking) => {
      if (moment(date).startOf('day').isAfter(moment(booking.startDate))) {
        return false
      }

      if (moment(date).endOf('day').isBefore(moment(booking.startDate))) {
        return false
      }

      return (
        product.id == booking.productId || product.id == booking.linkedProductId
      )
    })
  }

  public readValues() {
    if (!this.isSaved) {
      return null
    }

    const result = {
      key: this.key,
      participantCount: this.participantCount,
      targetLinkedProductId: this.targetLinkedProductId
    }

    this.initialize()

    return result
  }

  public getKey(productId: string, date: string): string {
    return `${productId}_${date}`
  }
}
